
import React, { useEffect, useState, useRef } from 'react';
import { IMPACT_METRICS } from '../constants';
import './ImpactMetrics.css';

const MetricCard: React.FC<{ label: string; value: number; suffix: string }> = ({ label, value, suffix }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const end = value;
    
    const timer = setInterval(() => {
      start += Math.ceil(end / 50);
      if (start >= end) {
        start = end;
        clearInterval(timer);
      }
      setCount(start);
    }, 40);

    return () => clearInterval(timer);
  }, [value, isVisible]);

  return (
    <div ref={cardRef} className="ImpactMetrics_card">
      <div className="ImpactMetrics_value" aria-live="polite" translate="no">
        {count.toLocaleString('id-ID')}
        <span className="ImpactMetrics_suffix">{suffix}</span>
      </div>
      <div className="ImpactMetrics_label">
        {label}
      </div>
    </div>
  );
};

const ImpactMetrics: React.FC = () => {
  return (
    <section className="ImpactMetrics_section">
      <div className="container">
        <div className="ImpactMetrics_grid">
          {IMPACT_METRICS.map((metric) => (
            <MetricCard
              key={metric.id}
              label={metric.label}
              value={metric.value}
              suffix={metric.suffix}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactMetrics;
